import { useCallback, useEffect, useState } from 'react';

import { applyTheme, getStoredTheme, setStoredTheme } from '@shared/theme';

export function useTheme() {
  const [theme, setThemeState] = useState(() => getStoredTheme());

  useEffect(() => {
    applyTheme(theme);
  }, [theme]);

  const setTheme = useCallback((nextTheme) => {
    setThemeState(setStoredTheme(nextTheme));
  }, []);

  return { theme, setTheme };
}
